import axios from 'axios';

export const purchaseOrderApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/purchase-order`,
    headers: {
        'Content-Type': 'application/json'
    }
})